import { StatusColorType } from "@/components/atoms/Status/styled";
import { fakeI18n } from "@/i18n";
import { InvoiceStatus } from "@/shared/domain/invoices";

interface InvoiceStatusMapped {
    id?: string;
    labelKey?: string;
    color?: StatusColorType;
    hexColor?: string;
    textBeforeDate?: string;
}

export const invoiceStatusMapped: InvoiceStatusMapped[] = [
    {
        id: InvoiceStatus.PAID,
        color: StatusColorType.Info,
        hexColor: "var(--color-info)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.COMPENSATED,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.PARTIALLY_PAID,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.NOT_PAID,
        color: StatusColorType.Error,
        hexColor: "var(--color-error)",
        textBeforeDate: fakeI18n.t("Invoices.Before"),
    },
    {
        id: InvoiceStatus.SEND_BACK_TO_COMPANY,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.SEND_BANK,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.REFUNDED,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
    {
        id: InvoiceStatus.PAID_BY_PAYMENT_PLAN,
        color: StatusColorType.Warning,
        hexColor: "var(--color-warning)",
        textBeforeDate: "",
    },
];

export const getInvoiceStatus = (id: string): InvoiceStatusMapped => {
    return invoiceStatusMapped.find((item) => item.id === id) || {};
};
